import React, { useState } from 'react';
import AdminHeader from './AdminHeader';
import UserManagement from './UserManagement';
import PermissionManagement from './PermissionManagement';
import './People.css';

function People({ onNavigate, currentView }) {
  const [activeTab, setActiveTab] = useState('users');

  return (
    <>
      <AdminHeader currentView={currentView} onNavigate={onNavigate} />
      <div className="people-container">
        <div className="people-header">
          <h1>People & Access</h1>
          <p className="people-subtitle">Manage users, roles, and permissions</p>
        </div>

        <div className="people-tabs">
          <button
            className={`tab-button ${activeTab === 'users' ? 'active' : ''}`}
            onClick={() => setActiveTab('users')}
          >
            Users
          </button>
          <button
            className={`tab-button ${activeTab === 'roles' ? 'active' : ''}`}
            onClick={() => setActiveTab('roles')}
          >
            Roles & Permissions
          </button>
        </div>

        <div className="people-content">
          {activeTab === 'users' && (
            <UserManagement onNavigate={onNavigate} currentView="people" embedded={true} />
          )}
          {activeTab === 'roles' && (
            <PermissionManagement onNavigate={onNavigate} currentView="people" embedded={true} />
          )}
        </div>
      </div>
    </>
  );
}

export default People;
